import * as React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import { TeamViewPageDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'

import TeamView from 'modules/calendar/components/TeamView'
import { useCalendarLeaves } from 'modules/calendar/hooks/useCalendarLeaves'
import type { RouteContextParams } from 'modules/calendar/lib/RouteContextParams'
import contractVersions from 'modules/contracts/store/collections/contractVersions'

const TeamViewPage = () => {
  const { date, filtersForm, loading, range, onDateRangeChange, canSeeCalendar } =
    useOutletContext<RouteContextParams>()
  const { lastLeaveUpdatedInMilliseconds } = useCalendarLeaves()
  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )
  const { loading: loadingCalendarAccess, data } = useQuery(TeamViewPageDocument, {})

  const canCompanyCalendarAccess = Boolean(data?.attendance._policies.companyCalendarAccess.can)

  return (
    <TeamView
      lastLeaveUpdatedInMilliseconds={lastLeaveUpdatedInMilliseconds}
      filtersForm={filtersForm}
      date={date}
      loading={loading || loadingContractVersions || loadingCalendarAccess}
      range={range}
      onDateRangeChange={onDateRangeChange}
      canSeeCalendar={canSeeCalendar}
      canCompanyCalendarAccess={canCompanyCalendarAccess}
      contractVersions={contractVersions}
    >
      <Outlet />
    </TeamView>
  )
}

export default TeamViewPage
